import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Dialog } from '../others/Dialog';
import { ActionButtons } from '../others/ActionButtons';
import { useTranslation } from 'react-i18next';

export const DialogSelectCompany = ({
    openDialogConfirm,
    handleCancelConfirm,
    titleDialog,
    handleConfirmAction,
    data
}) => {
    const { t } = useTranslation();
    const finaltitleDialog = titleDialog || t("messages.selectCompany");
    const [reg, setReg] = useState('');

    // useEffect(() => {
    //     if (data && data.length === 1)
    //         handleConfirmAction(data[0]);
    // }, [data, handleConfirmAction])

    const handleChange = () => {
        handleConfirmAction(data.find(e => e.id_company === reg));
    }

    return (
        <Dialog
            openDialog={openDialogConfirm}
            widthDialog="xs"
            styleDialog={{
                width: '350px',
            }}
            title={finaltitleDialog &&
                <Typography
                    sx={{ fontWeight: 'bold', fontSize: 17 }}
                >
                    {finaltitleDialog}
                </Typography>
            }
            styleTitle={finaltitleDialog && { px: 3, pt: 3 }}
            content={
                <Box sx={{ mt: 2 }}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormControl
                            fullWidth
                            size="small"
                        >
                            <InputLabel>{t("selectPlaceholder")}</InputLabel>
                            <Select
                                label={t("selectPlaceholder")}
                                name="companySelectId"
                                value={reg}
                                onChange={(e) => setReg(e.target.value)}
                            >
                                {data.map((item) => (
                                    <MenuItem key={item.id_company} value={item.id_company}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Box>
            }
            styleContent={{}}
            actions={
                <Grid size={{ md: 12 }}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        py: 1
                    }}
                >
                    <ActionButtons
                        onCancel={handleCancelConfirm}
                        onSubmit={handleChange}
                        disabledSubmit={!reg}
                    />
                </Grid>
            }
        />
    )
}
